import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
var LabeledTooltip = function (_a) {
    var label = _a.label, tooltipText = _a.tooltipText;
    return (_jsxs("div", { style: { display: 'inline-flex', alignItems: 'center', gap: '4px' }, children: [label, tooltipText && (_jsx(Tooltip, { title: tooltipText, styles: { root: { position: 'fixed' } }, children: _jsx(InfoCircleOutlined, {}) }))] }));
};
export default memo(LabeledTooltip);
